import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)

// 状態`Auth`と状態`UserInfo`をVuexのstateで一元管理出来るよう定義する
const state = {
  // 状態`Auth`
  auth: {
    // 医療機関コード
    ircd: '',
    // システムID
    trsq: '',
    // ユーザーID
    userId: '',
    // `token`はlocalstorageから取得する
    token: ''
  },
  adminLoginUserInfo: {
    // IRKN_IRNM : 医療機関名称
    irnm : ''
  },
  adminUserChoice: {

    // 以下各マスタ操作時のストア値=======S

    // 管理者用グローバルメニューの状態
    // 0:デフォルト表示（何も表示しない）
    // 1:トップ
    // 2:予約管理系メニュー表示
    // 3:マスタ管理系メニュー表示
    statusGlobalMenu: '0',

    // 時間帯マスタ操作時
    MasterWTMZN: {
      // 時間帯コード
      tmzn: '',
      err:''
    },

    // 検査項目マスタ操作時
    MasterWKKMM: {
      // 検査項目コード
      kmcd: ''
    },

    // 予約枠マスタ操作時
    MasterWWAKU: {
      // 予約枠コード
      waku: ''
    },

    // メールテンプレートマスタ操作時
    MasterWMAIL: {
      // 管理コード
      mrcd: ''
    },

    // オプション分類マスタ操作時
    MasterWOPBR: {
      // オプション分類
      opbr: ''
    },

    // オプション項目マスタ操作時
    MasterWOPKM: {
      // オプション分類
      opbr: '',
      // オプションコード
      opcd: ''
    },

    // クライアントマスタ操作時
    MasterWJGYO: {
      // クライアントコード
      jgcd: ''
    },

    // 対象者区分マスタ操作時
    MasterWHFKB: {
      // クライアントコード
      jgcd: '',
      // 対象者コード
      hfkb: ''
    },

    // コースマスタ操作時
    MasterWIRKS: {
      
      // 検索用クライアントコード
      searchJgcd: '',

      // 年度
      nend: '',
      // クライアントコード
      jgcd: '',
      // 健診コースコード
      kscd: '',
      // キー
      key: '',
    },

    // 受診者抽出操作時
    MasterWIGA1: {
      // 予約受付番号
      ukno: '',
      // 予約変更日（と時間帯）
      changeDateFlag: false,
      // 予約変更日　年
      changeDateYear: 0,
      // 予約変更日　月
      changeDateMonth: 0,
      // 予約変更日　日
      changeDateDate: 0,
      // 予約変更日　時間帯
      changeDateTmzn: '',
    },

    // CSVパターン
    CSVPattern: {
      // パターンコード
      ptcd: ''
    },

    // 以下各マスタ操作時のストア値=======E
  },
  // 受診者抽出画面　絞り込み欄
  adminWiga11Search: {
    // クライアントコード
    jgcd: '',
    
    // 健康保険組合名
    jgnm: '',
    
    // 企業名
    cmnm: '',

    // 保険証記号
    hkkg: '',

    // 患者番号
    trno: '',

    // 予約枠
    waku: '',
    
    // 予約番号
    ukno: '',
    
    // 予約年度
    nend: 0,

    // オプション分類コード
    opbr: '',

    // オプション項目コード
    opcd: '',

    // 受診日
    ykdyStartYear: 0,
    ykdyStartMonth: 0,
    ykdyStartDate: 0,
    ykdyEndYear: 0,
    ykdyEndMonth: 0,
    ykdyEndDate: 0,

    // 予約登録日
    crdtStartYear: 0,
    crdtStartMonth: 0,
    crdtStartDate: 0,
    crdtEndYear: 0,
    crdtEndMonth: 0,
    crdtEndDate: 0,

    // 予約更新日
    updtStartYear: 0,
    updtStartMonth: 0,
    updtStartDate: 0,
    updtEndYear: 0,
    updtEndMonth: 0,
    updtEndDate: 0,

    // ステータス（ステータスコード）
    ykst: [],

    // カナ氏名
    ryak: '',

    // 漢字氏名
    name: '',

    // ダウンロード状況
    csst: [],

    // 受診時間（時間帯コード）
    tmzn: '',
    
  },
  // 以下より一般ユーザー系
  commonUserInfo: {
		// 一般用ナビゲーション表示の切り替え
		// true: 表示
		// false: 非表示
		isDisplayNavigation: false,
    // URLパラメーター
    pram: '',
    // 医療機関名称
    irnm: '',
    // 受診者名
    name: '',
    // 契約先 電話番号
    ktel: '',
    // 電話予約受付時間
    uktk: '',
    // 背景画像相対パス
    hmpg: '',
    // マイページ
    myPage: {
      // マイページ画面を通ったかどうか
      isUse: false,
      // 変更する予約受付番号
      choiceUkno: '',
      // 詳細を閲覧する予約受付番号
      detailUkno: '',
      // キャンセルする予約受付番号
      cancelUkno: ''
    },
    // 新規健保予約画面
    newHealthInsurance: {
      // 新規健保予約画面を通ったかどうか
      isUse: false,
      // クライアントコード
      jgcd: '',
      // 保険者番号
      hksh: '',
      // 性別
      sex: '',
      // 生年月日 年
      btdyYear: 0,
      // 生年月日 月
      btdyMonth: 0,
      // 生年月日 日
      btdyDate: 0,
      // 年度
      nend: 0,
      // 年齢
      age: 0,
      // 対象者区分
      hfkb: '',
    },
    // コース一覧画面
    selectCourse: {
      // 選択したコースコード
      kscd: '',
      // 選択したコース条件コード
      jkcd: ''
    },
    // オプション一覧画面
    selectOption: {
      // 選択したオプション分類コード
      opbr: [],
      // 選択したオプション項目コード
      opcd: [],
      // 選択したオプション条件コード
      jkcd: []
    },
    // カレンダー選択画面
    selectCalender: {
      // カレンダー画面を通ったかどうか
      isUse: false,
      // 選択した予約日付
      date: '',
      // 選択した予約時間帯
      tmzn: ''
    },
    // 予約情報入力画面
    inputReserveInfo: {
      // クライアント名（健康保険組合名）
      jgnm: '',
      // 保険証記号
      hkkg: '',
      // 保険証番号
      hkno: '',
      // 企業名
      cmnm: '',
      // 漢字氏名
      nam1: '',
      nam2: '',
      // カナ氏名
      ryk1: '',
      ryk2: '',
      // ご住所
      // 郵便番号
      zip1: '',
      zip2: '',
      // 都道府県
      adr1: '',
      // 住所１（市区町村）
      adr2: '',
      // 住所２（番地）
      adr3: '',
      // 電話番号（日中連絡先）
      tel1: '',
      // 社員番号
      syno: '',
      // メールアドレス
      email: '',
      // ＤＭ・メルマガ 0:受け取らない、1:受け取る
      dmkb: '',
      // 備考
      mem1: '',

      // 個人情報登録用のパラメータ
      // コース選択やオプション選択には使用されない

      // 性別
      sex: '',
      // 生年月日 年
      btdyYear: 0,
      // 生年月日 月
      btdyMonth: 0,
      // 生年月日 日
      btdyDate: 0,
      // 年度
      nend: 0,
      // 年齢
      age: 0,
      // 対象者区分
      hfkb: '',
    },

    // 予約確認画面
    confirmReserveInfo: {
      // 予約確認画面を通ったかどうか
      isUse: false,
      // 年齢
      age: 0
    },

    // 予約確定画面
    reserveResult: {
      ukno: ''
    },

    // 途中ログイン（未使用）
    enRouteLogin: {
      // 途中ログイン画面でログインしたかどうか
      isUse: false
    }
  }
}

export default new Vuex.Store({
  // プラグイン
  plugins: [createPersistedState()],
  state,
  getters,
  actions,
  mutations,
  // 実行モード
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store/index.js